import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import {
  CalendarMonth as PlanningIcon,
  Dashboard as DashboardIcon,
  Engineering as EngineeringIcon,
  Inventory as AssetsIcon,
  RocketLaunch as DeliveryIcon,
} from '@mui/icons-material';
import { useSearchParams } from 'react-router-dom';
import H22026ProgressDashboard from './H22026ProgressDashboard';
import H22026ProductEngineering from './H22026ProductEngineering';
import H22026Assets from './H22026Assets';
import H22026DeliveryView from './H22026DeliveryView';

const PRIMARY = '#0f1f3d';
const NAVY2   = '#1a3460';
const TAB_MAP = { dashboard: 0, 'product-engineering': 1, assets: 2, delivery: 3 };

const NAV_ITEMS = [
  { icon: DashboardIcon,   label: 'Dashboard' },
  { icon: EngineeringIcon, label: 'Product Engineering' },
  { icon: AssetsIcon,      label: 'Assets' },
  { icon: DeliveryIcon,    label: 'Delivery' },
];

const H22026Dashboard = () => {
  const [searchParams] = useSearchParams();
  const initialTab    = searchParams.get('tab');
  const initialFilter = searchParams.get('filter');

  const [tabValue, setTabValue] = useState(
    initialTab && TAB_MAP[initialTab] !== undefined ? TAB_MAP[initialTab] : 0
  );
  const [pillarFilter, setPillarFilter] = useState(initialFilter || '');

  useEffect(() => {
    if (initialTab && TAB_MAP[initialTab] !== undefined) setTabValue(TAB_MAP[initialTab]);
  }, [initialTab]);

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', bgcolor: '#edf1f7', minHeight: '100%', borderRadius: 2, p: 0 }}>
      {/* Header */}
      <Box sx={{
        background: `linear-gradient(105deg, ${PRIMARY} 0%, ${NAVY2} 100%)`,
        borderRadius: '12px 12px 0 0',
        px: 3, py: 2,
        display: 'flex', alignItems: 'center', gap: 2,
      }}>
        <Box sx={{
          width: 40, height: 40, borderRadius: '10px', flexShrink: 0,
          bgcolor: 'rgba(255,255,255,0.15)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <PlanningIcon sx={{ color: '#fff', fontSize: 22 }} />
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 720, fontSize: 20, letterSpacing: '-0.3px', color: '#fff', lineHeight: 1.2 }}>
            Compliance H2-2026 Delivery
          </Typography>
          <Typography sx={{ fontSize: 13, color: '#cfe0eb', mt: 0.3 }}>
            Operational Compliance &amp; Azure Gov Compliance — H2 2026 planning and delivery tracking
          </Typography>
        </Box>
      </Box>

      {/* Tab bar */}
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #dfe5ee', px: 1.5 }}>
        <Box sx={{ display: 'flex', gap: 0.25, py: 0.5 }}>
          {NAV_ITEMS.map((item, idx) => {
            const Icon = item.icon;
            const active = tabValue === idx;
            return (
              <Box
                key={idx}
                onClick={() => setTabValue(idx)}
                sx={{
                  display: 'flex', alignItems: 'center', gap: 0.75,
                  px: 1.75, py: 0.75, borderRadius: '8px', cursor: 'pointer',
                  transition: 'all 0.15s',
                  bgcolor: active ? '#edf1f7' : 'transparent',
                  '&:hover': { bgcolor: active ? '#edf1f7' : 'rgba(0,0,0,0.04)' },
                }}
              >
                <Icon sx={{ fontSize: 17, color: active ? PRIMARY : '#6d788c' }} />
                <Typography sx={{
                  fontSize: 13, fontWeight: active ? 650 : 450,
                  color: active ? PRIMARY : '#6d788c',
                  letterSpacing: active ? '-0.1px' : 0,
                }}>
                  {item.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ p: 2.5 }}>
        {tabValue === 0 && (
          <H22026ProgressDashboard
            onPillarClick={(key) => { setPillarFilter(key); setTabValue(1); }}
          />
        )}
        {tabValue === 1 && (
          <H22026ProductEngineering initialFilter={pillarFilter} />
        )}
        {tabValue === 2 && <H22026Assets />}
        {tabValue === 3 && <H22026DeliveryView />}
      </Box>
    </Box>
  );
};

export default H22026Dashboard;
